module.exports = __webpack_public_path__ + "license_risk_high.png";